import React from "react";

export default function Index() {
	return (
		<div>
			<h1>Test Page</h1>
		</div>
	);
}
